<template>
  <v-row class="mt-6 mb-16 pb-6 mx-1">
    <v-col class="ma-0 pa-0" cols="12" v-for="(filter, i) in filters" :key="i">
      <div
        v-if="filter['type'] === 'report_date_month_range'"
        class="myfilters poppins"
      >
        <FilterDateMonthRange
          :filter="filter"
          ref="filter"
        ></FilterDateMonthRange>
      </div>
      <div v-if="filter['type'] === 'select2Single'" class="myfilters poppins">
        <FilterSelect :filter="filter" ref="filter"></FilterSelect>
      </div>
      <div v-if="filter['type'] === 'range'" class="myfilters poppins">
        <FilterRangeSlider :filter="filter" ref="filter"></FilterRangeSlider>
      </div>
      <div v-if="filter['type'] === 'phone'" class="myfilters poppins">
        <FilterPhone :filter="filter" ref="filter"></FilterPhone>
      </div>
      <div
        v-if="filter['type'] === 'multiImageSelect'"
        class="myfilters poppins"
      >
        <FilterMultiSelectWithImage
          :filter="filter"
          ref="filter"
        ></FilterMultiSelectWithImage>
      </div>
      <div v-if="filter['type'] === 'multipleSelect'" class="myfilters poppins">
        <FilterMultiSelect :filter="filter" ref="filter"></FilterMultiSelect>
      </div>
      <div
        v-else-if="filter['type'] === 'limited_date_range'"
        class="myfilters poppins"
      >
        <FilterDateLimited :filter="filter" ref="filter"></FilterDateLimited>
      </div>
      <div v-else-if="filter['type'] === 'date'" class="myfilters poppins">
        <FilterDate :filter="filter" ref="filter"></FilterDate>
      </div>
      <div
        v-else-if="filter['type'] === 'date_unlimited'"
        class="myfilters poppins"
      >
        <FilterDateUnlimited
          :filter="filter"
          ref="filter"
        ></FilterDateUnlimited>
      </div>
      <div
        v-else-if="filter['type'] === 'select2DateRange'"
        class="myfilters poppins"
      >
        <!--        <FilterDateRangeWithSelect-->
        <!--          :filter="filter"-->
        <!--          ref="filter"-->
        <!--        ></FilterDateRangeWithSelect>-->
        <FilterDateRangeWithSelectNew
          :filter="filter"
          ref="filter"
        ></FilterDateRangeWithSelectNew>
      </div>
      <div v-else-if="filter['type'] === 'inputText'" class="myfilters poppins">
        <FilterTextInput
          :submitFilterValues="submitFilterValues"
          :filter="filter"
          ref="filter"
        ></FilterTextInput>
      </div>
      <div
        v-else-if="filter['type'] === 'inputTextMultiple'"
        class="myfilters poppins me-2 mb-6 min-h-25px"
      >
        <FilterTextInputMultipleNew :filter="filter" ref="filter" />
        <!--        <FilterTextInputMultiple-->
        <!--          :filter="filter"-->
        <!--          ref="filter"-->
        <!--        ></FilterTextInputMultiple>-->
      </div>
    </v-col>
  </v-row>
</template>

<script>
import FilterMultiSelectWithImage from "@/own/components/filter/filterTypes/FilterMultiSelectWithImage.vue";
import FilterMultiSelect from "@/own/components/filter/filterTypes/FilterMultiSelect.vue";
import FilterSelect from "@/own/components/filter/filterTypes/FilterSelect.vue";
import FilterPhone from "@/own/components/filter/filterTypes/FilterPhone.vue";
import FilterRangeSlider from "@/own/components/filter/filterTypes/FilterRangeSlider.vue";
import FilterDateMonthRange from "@/own/components/filter/filterTypes/FilterDateMonthRange.vue";
import FilterDate from "@/own/components/filter/filterTypes/FilterDate.vue";
import FilterDateLimited from "@/own/components/filter/filterTypes/FilterDateLimited.vue";
import FilterDateUnlimited from "@/own/components/filter/filterTypes/FilterDateUnlimited.vue";
// import FilterDateRangeWithSelect from "@/own/components/filter/filterTypes/FilterDateRangeWithSelect.vue";
import FilterDateRangeWithSelectNew from "@/own/components/filter/filterTypes/FilterDateRangeWithSelectNew.vue";
import FilterTextInput from "@/own/components/filter/filterTypes/FilterTextInput.vue";
// import FilterTextInputMultiple from "@/own/components/filter/filterTypes/FilterTextInputMultiple.vue";
import FilterTextInputMultipleNew from "@/own/components/filter/filterTypes/FilterTextInputMultipleNew.vue";
export default {
  name: "FilterSelector",
  components: {
    FilterMultiSelect,
    FilterDateMonthRange,
    FilterSelect,
    FilterRangeSlider,
    FilterPhone,
    FilterMultiSelectWithImage,
    FilterDate,
    FilterDateLimited,
    // FilterDateRangeWithSelect,
    FilterDateRangeWithSelectNew,
    FilterTextInput,
    // FilterTextInputMultiple,
    FilterTextInputMultipleNew,
    FilterDateUnlimited,
  },
  props: ["filters", "submitFilterValues"],
  methods: {
    clearData: function () {
      this.$refs.filter.forEach((filter) => {
        filter.resetFilterData();
      });
    },
  },
};
</script>
